import { NgModule } from '@angular/core';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CookieModule } from 'ngx-cookie';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


import { UiModule } from './ui/ui.module';
import { PlatformModule } from './platform/platform.module';
import { FirebaseModule } from "./firebase/firebase.module";
import { MailchimpModule } from "./mailchimp/mailchimp.module";
import { Angulartics2Module } from 'angulartics2';
import { Angulartics2RouterlessModule } from 'angulartics2/routerlessmodule';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import {NgcCookieConsentModule, NgcCookieConsentConfig} from 'ngx-cookieconsent';
import { SimpleNotificationsModule } from 'angular2-notifications';


const cookieConfig:NgcCookieConsentConfig = {
  cookie: {
    domain: "arkheim.com"
  },
  position: "bottom",
  theme: "edgeless",
  palette: {
    popup: {
      background: "#000000",
      text: "#ffffff",
      link: "#ffffff"
    },
    button: {
      background: "#f1d600",
      text: "#000000",
      border: "transparent"
    }
  },
  type: "info"
};


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'startpage'}),
    BrowserTransferStateModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    UiModule,
    PlatformModule,
    FirebaseModule,
    MailchimpModule,
    CookieModule.forRoot(),
    NgcCookieConsentModule.forRoot(cookieConfig),
    SimpleNotificationsModule.forRoot(),
    AppRoutingModule, //Important! needs always to be the last one to ensure wild-card routing is last added to the router!
    Angulartics2RouterlessModule.forRoot({
      pageTracking: {
        clearIds: true,
        clearHash: false,
      }
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
